<template>
  <form-layout :title="data ? data.title : 'Recommandation du traitement'" :class="'treatment-recommandation'" :isTitleReco="true">

    <slot>
      <!-- Si on a pas de reco -->
      <div class="treatment-message treatment-error" v-if="!data">
        <span class="u-color--red"><strong>Désolé… </strong></span>Nous ne sommes pas en mesure de fournir une recommandation de traitement pour ce diagnostic. <a @click="showModal" class="link u-color--red">Soyez prévenu quand cette recommandation sera disponible</a>
      </div>
      <modal-contact v-show="isModalVisible"
                     @close="closeModal"
      />

      <!-- Si on a une reco -->
      <div class="treatment-message treatment-warning" v-if="data && data.warning" v-html="data.warning"></div>

      <div v-if="data">
        <div class="recommanded-treatment" v-for="(section, index) in data.sections.edges" :key="index">


          <div :class="isStrong(section)">

            <!-- Section des titles -->
            <div class="title-recommandation">
              <div class="part-left">

				<!-- Title strongly recommanded -->
				<span v-if="isStrong(section)==='highly-recommanded'">
					<img src="@/assets/img/icons.svg#icon-reco" width="14" height="12"/> Recommandation <u>forte</u>
					<a href="/info/les-grades-des-recommandations" class="popin" target="_blank"></a>
				</span>

				<!-- Title weakly recommanded -->
				<span v-if="isStrong(section)==='weakly-recommanded'">
					Recommandation <u>faible</u>
					<a href="/info/les-grades-des-recommandations" class="popin" target="_blank"></a>
				</span>

				<!-- Title neutral recommanded -->
				<span v-if="isStrong(section)==='neutraly-recommanded'">
					Recommandation
					<a href="/info/les-grades-des-recommandations" class="popin" target="_blank"></a>
				</span>

				<!-- Title amm not recommanded -->
				<span v-if="isStrong(section)==='outofy-recommanded'">
					<img src="@/assets/img/icons.svg#icon-warning" width="14" height="12"/>
					Hors reco mais avec <abbr title="Autorisation de Mise sur le Marché">AMM</abbr>
					<a href="/info/les-grades-des-recommandations" class="popin" target="_blank"></a>
				</span>

				<!-- Title ma -->
				<span v-if="isStrong(section)==='ma-recommanded'">
					Mesures associées au traitement
				</span>

              </div>
              <div class="part-right">
                <span>au {{parseDate(section.node.date)}}</span>
              </div>
            </div>

            <!-- Contenu des grades -->

            <div class="content u-color--grey-dark">

              <div class="grade grade-0" v-if="section.node.body">
                <div class="content-body" v-html="section.node.body"></div>
              </div>

              <div class="grade agrade" v-if="section.node.grade0">
                <span class="title">
                  <a class="popin" href="/info/les-grades-des-recommandations" target="_blank" title="Voir la définition des grades">Non gradé</a>
                </span>
                <div class="content-body" v-html="section.node.grade0"></div>
              </div>

              <div class="grade grade-A" v-if="section.node.grade1">
                <span class="title">
                  <a class="popin" href="/info/les-grades-des-recommandations" target="_blank" title="Voir la définition des grades">Grade A</a>
                </span>
                <div class="content-body" v-html="section.node.grade1"></div>
              </div>

              <div class="grade grade-B" v-if="section.node.grade2">
                <span class="title">
                  <a class="popin" href="/info/les-grades-des-recommandations" target="_blank" title="Voir la définition des grades">Grade B</a>
                </span>
                <div class="content-body" v-html="section.node.grade2"></div>
              </div>

              <div class="grade grade-C" v-if="section.node.grade3">
                <span class="title">
                  <a class="popin" href="/info/les-grades-des-recommandations" target="_blank" title="Voir la définition des grades">Grade C</a>
                </span>
                <div class="content-body" v-html="section.node.grade3"></div>
              </div>

              <div class="grade grade-AE" v-if="section.node.expertOpinion">
                <span class="title">
                  <a class="popin" href="/info/les-grades-des-recommandations" target="_blank" title="Voir la définition des grades">Avis d'expert</a>
                </span>
               <div class="content-body expert-opinion" v-html="section.node.expertOpinion"></div>
              </div>

              <div class="grade grade-NB" v-if="section.node.notaBene">
                <span class="title">
                  <a class="popin" href="/info/les-grades-des-recommandations" target="_blank" title="Voir la définition des grades">NB</a>
                </span>
                <div class="content-body" v-html="section.node.notaBene"></div>
              </div>

              <div class="grade grade-Note" v-if="section.node.grade4">
                <span class="title">
                  Notes
                </span>
                <div class="content-body" v-html="section.node.grade4"></div>
              </div>

              <div class="grade grade-Reference" v-if="section.node.grade5">
                <span class="title">
                  R&eacute;f&eacute;rences
                </span>
                <div class="content-body" v-html="section.node.grade5"></div>
              </div>

            </div>

          </div>
        </div>
      </div>

      <!-- Reco footer -->
      <div class="footer" v-if="data" v-html="data.footer"></div>
    </slot>

  </form-layout>
</template>

<script>
  import FormLayout from './../Layout/FormLayout'
  import ModalContact from "../Modal/Models/Modal-contact";

  export default {
    name: "TreatmentRecommandation",
    components: {
      ModalContact,
      FormLayout},
    data () {
      return {
        isModalVisible: false,
      };
    },
    methods: {
      isStrong(section) {
//      return section.node.pertinence === 'strong'
        switch(section.node.pertinence){
          case 'strong':
            return 'highly-recommanded';
          case 'weak':
            return'weakly-recommanded';
          case 'amm':
            return'outofy-recommanded';
          case 'measures':
            return'ma-recommanded';
          case 'neutral':
            return'neutraly-recommanded';
          default:
            return'default-recommanded';
        }
      },
      parseDate(date) {
        let d = date.split(' ')[0].split('-'),
          event = new Date(Date.UTC(d[0], d[1] - 1, d[2], 0, 0, 0)),
//        event = new Date(Date.UTC(d[0], d[1], d[2], 0, 0, 0)),
          options = { year: 'numeric', month: 'numeric', day: 'numeric' };

        return event.toLocaleDateString('fr-FR', options)
      },
      showModal() {
        this.isModalVisible = true;
      },
      closeModal() {
        this.isModalVisible = false;
      }
    },
    props: ['data']
  }
</script>

<style lang="scss">

	.treatment-recommandation {

		padding: rem(30px) rem(40px);

		sup {line-height:0;padding-left:.2em;color:#806A13}


		.title-recommandation {

			padding: rem(10px) rem(20px);
			width: 100%;
			display: flex;
			flex-direction: row;
			flex-wrap: wrap;
			justify-content: space-between;
			align-items: center;

			color: color(grey-soft);
			background-color:#EEE;


			.part-left img {
				margin-right: rem(5px);
			}

	        .part-left span {
	          font-size: rem(14px);
	          font-weight: 600;
	          line-height: rem(30px);
	          text-transform: uppercase;
	          padding-right:.3em;

	          a.popin {
	          	display:inline-block;
	          	width:14px;
	          	height:14px;
	          	margin-left:.33em;
	          	background:url(/img/icons.57ddb455.svg#icon-infos) no-repeat center center;
	          	background-size:contain;
	          }

	          @include mq($until: MD) {
	            font-size: rem(12px);
	          }
	        }

	        @include mq($until: MD) {
	          padding: rem(8px) rem(9px);
	        }

	}

	.ma-recommanded .title-recommandation,
	.highly-recommanded .title-recommandation {
		background-color:#50940C;

		span {
		  color:#FFF !important
		}

		.part-left span a.popin {filter:saturate(0) brightness(0) invert(1)}

	}

	.weakly-recommanded .title-recommandation {
		background-color:#50940C + 200;
	}

	.outofy-recommanded .title-recommandation {
		background-color:#ffeeee;
	}

	.ma-recommanded .title-recommandation {
		background-color:#0082A3;
	}



    .treatment-title {
      display: flex;
      align-items: center;
      justify-content: space-between;
      flex-wrap: wrap;
      position: relative;
      padding-bottom: rem(15px);
      margin-bottom: rem(30px);

      &::after {
        content: '';
        height: 1px;
        width: 100%;
        position: absolute;
        background-color: color(border);
        bottom: 0;
        left: 0;
      }

    }

    .treatment-message {
      padding: rem(10px) rem(20px);
      border-radius: 2px;
      font-size: rem(14px);
      margin-bottom: rem(20px);

      &.treatment-error {
        background-color: color(red-soft);

        a {
          cursor: pointer;
        }
      }

      &.treatment-warning {
        color:purple;
        background-color: color(red-soft);

        ul {padding-left:2em}

      }
    }

    .recommanded-treatment {

      box-shadow: 0 2px 6px 0 rgba(0,0,0,0.08);
      border: 1px solid color(border);
      margin-bottom: rem(20px);

      .treatment-title {

        font-size: rem(13px);
        line-height: rem(18px);
        text-transform: initial;

        .part-left {
          display: flex;
          flex-direction: row;
          align-items: center;

          @include mq($until: MD) {
            .source {
              display: none;
            }
          }
        }
      }

      .part-right {
        position: relative;
        padding-left: rem(15px);
        font-size: rem(13px);

        @include mq($until: MD) {
          display: none;
        }

        span {
          font-weight: 100;
          color:black;
        }

      }


      .content {
        padding: rem(20px);
        font-size: rem(14px);
        line-height: rem(24px);

        .pdf {
          display: flex;

          .icon {
            background-image:url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 32 32'%3E %3Cg fill='%23d22600'%3E %3Cpath d='M9.44,20.59c0-.53-.37-.85-1-.85a2.7,2.7,0,0,0-.54.05V21.5a2.51,2.51,0,0,0,.44,0C9,21.53,9.44,21.18,9.44,20.59Z' /%3E %3Cpath d='M13.46,19.76a2.47,2.47,0,0,0-.59,0v3.77a2,2,0,0,0,.45,0,1.79,1.79,0,0,0,1.95-2A1.65,1.65,0,0,0,13.46,19.76Z' /%3E %3Cpath d='M20.93,0H8.1A3.41,3.41,0,0,0,4.7,3.41V16H4.37A1.37,1.37,0,0,0,3,17.37V25.7a1.37,1.37,0,0,0,1.37,1.37H4.7v1.52A3.41,3.41,0,0,0,8.1,32H25.6A3.41,3.41,0,0,0,29,28.59V8.06ZM6.59,18.87a12,12,0,0,1,1.76-.11,2.73,2.73,0,0,1,1.76.46,1.68,1.68,0,0,1,.62,1.33,1.84,1.84,0,0,1-.53,1.37,2.65,2.65,0,0,1-1.87.61l-.45,0v2.06H6.59Zm19,11H8.1a1.33,1.33,0,0,1-1.32-1.32V27.07H23.1a1.37,1.37,0,0,0,1.37-1.37V17.37A1.37,1.37,0,0,0,23.1,16H6.78V3.41A1.33,1.33,0,0,1,8.1,2.09h12V6.54A2.36,2.36,0,0,0,22.51,8.9h4.36l.05,19.7A1.32,1.32,0,0,1,25.6,29.91Zm-14-5.37V18.87a12.73,12.73,0,0,1,1.76-.11,3.68,3.68,0,0,1,2.36.61,2.57,2.57,0,0,1,1,2.18,2.94,2.94,0,0,1-1,2.33,4.11,4.11,0,0,1-2.66.75A10,10,0,0,1,11.56,24.54Zm9.33-3.35v1.06H18.82v2.32H17.51V18.8H21v1.07H18.82v1.32Z'/%3E %3C/g%3E %3C/svg%3E");
            background-repeat: no-repeat;
            height: rem(20px);
            width: rem(30px);
          }
        }

        ul {margin-left:3em}

        p {
          margin-top: 0;
        }

        .grade {
          padding: rem(15px) rem(20px) rem(20px);

          .title {
            line-height: rem(30px);
            text-transform: uppercase;
            font-weight: 600;
            display: flex;
            align-items: center;
            color:#0082A3;

            a {color:inherit}

            img {
              margin-right: rem(6px);
            }

            &+ div {
              margin-top:.3em;
              padding-top:.5em;
              border-top:1px solid #999;
            }

          }

          &+ .grade {padding-top:0}

          &.grade-Note,
          &.grade-Reference {

          	background-color:#EEE;
          	padding-top:0.9375rem;

          	.title {color:color(grey-soft)}

          }

        }
      }
    }

    @include mq($until: MD) {
      padding: 0 rem(10px) rem(20px);
    }

    .asterix {
      position: relative;
      padding-right: rem(10px);

      &::after {
        position: absolute;
        content: 'D';
        font-size: rem(8px);
        font-weight: 700;
        color: color(blue);
        transform: translate(50%, 50%);
        top: rem(-20px);
      }
    }

    .footer {
      font-size: rem(14px);
      line-height: rem(24px);
      font-weight: 200;
      position: relative;
      padding-top: rem(20px);
      margin-top: rem(30px);

      &::after {
        position: absolute;
        content: '';
        top: 0;
        left: 0;
        background-color: color(border);
        height: 1px;
        width: 100%;
      }
    }
  }

</style>

